import { Component, OnInit, ViewChild } from '@angular/core';
import { TabsetComponent } from 'ngx-bootstrap';

@Component({
  selector: 'app-customer-dashboard',
  templateUrl: './customer-dashboard.component.html'
})
export class CustomerDashboardComponent implements OnInit {
  activeTab;
  constructor() { }
  @ViewChild('artabset', { static: false }) artabset: TabsetComponent;
  ngOnInit() {

  }
  ngAfterViewInit() {
    if (localStorage.getItem("arCTActiveTab") !== null) {
      this.activeTab = localStorage.getItem("arCTActiveTab");
      //console.log(this.activeTab);
      if (this.activeTab) {
        this.goto(parseInt(this.activeTab));
      }
    } else {
      this.goto(0);
    }
  }
  goto(id) {
    if (id) {
      this.artabset.tabs[id].active = true;
    }
  }
}